<div *ngIf="reportType == 'AdvertisementAddressList'">



    <div class="container" id="print-section">
  <div style="margin-left: 80%; margin-bottom: 2%;">
  <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 5%; width: 40px;background-color: blue; display: none;"
    mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
    Print
  </button>

  <!-- PRINT BUTTON -->
<button class="noPrint" 
  style="background-color: #4A5FC1; color: #FFFFFF;
         padding: 6px 18px; font-size: 14px; font-weight: bold;
         border: none; border-radius: 8px;
         cursor: pointer; margin-right: 10px;"
  (click)="print()" 
  mat-raised-button>
  Print
</button>

<!-- EXPORT BUTTON -->
<button class="noPrint" 
  style="background-color: #4A5FC1; color: #FFFFFF;
         padding: 6px 18px; font-size: 14px; font-weight: bold;
         border: none; border-radius: 8px;
         cursor: pointer; margin-right: 10px;"
  (click)="exportExcel('Issue_Address_List')" 
  mat-raised-button>
  Export
</button>

<button mat-button class="noPrint"
  style="background-color: transparent; color: black;
         font-size: 14px; margin-left: 5px;"
  (click)="closeDialog()">
  Close
</button>



</div>

        <div style="text-align: center; font-weight: bold; font-size: xx-large; margin-bottom: 15px;">
          प्रतिनिधी पत्ते यादी
        </div>
      
        <div style="display: flex; justify-content: space-between; width: 100%; font-weight: bold; margin-bottom: 20px;">
          <!-- <span style="text-align: left; font-size: small;">अंक दिनांक :- {{ issueDates | date: 'dd-MM-yyyy' }}</span> -->
          <span style="text-align: right;">दिनांक :- {{ currentDate | date: 'dd-MM-yyyy' }}</span>
        </div>
      
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #000;">
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 12px; text-align: center;font-size: medium;font-weight: bold;">प्रतिनिधी</th>
              <th style="border: 1px solid #000; padding: 12px; text-align: center;font-size: medium;font-weight: bold;">ठिकान</th>
              <th style="border: 1px solid #000; padding: 12px; text-align: center;font-size: medium;font-weight: bold;">दुरध्वनी</th>
              <th style="border: 1px solid #000; padding: 12px; text-align: center;font-size: medium;font-weight: bold;">निव्वळ रक्कम</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data2 of Address">
              <td style="border: 1px solid #000; padding: 10px;font-weight: bold;font-size: medium;">{{ data2.issue_seller_name }}</td>
              <td style="border: 1px solid #000; padding: 10px;font-weight: bold;font-size: medium;">{{ data2.taluka }} - {{ data2.district }} - {{ data2.state }}  </td>
              <td style="border: 1px solid #000; padding: 10px;font-weight: bold;font-size: medium;">{{ data2.rep_mob_no }}</td>
              <td style="border: 1px solid #000; padding: 10px;font-weight: bold;font-size: medium; text-align: end;">{{ data2.net_amt }}</td>

            </tr>
          </tbody>
        </table>
    </div>
</div>